import React from "react";
import { CgCloseO } from "react-icons/cg";
import { useListManager } from "../../contexts/list.manager";
import Image from "../Image/Image";
import PageTitle from "../PageTitle/PageTitle";
import Spacer from "../Spacer/Spacer";
import "./FormTitle.css";

const FormTitle = ({ backRoute = null, ...props }) => {
	const { closeForm } = useListManager();

	const close = () => {
		closeForm();
	};
	return props.type === "consulta" ? (
		<React.Fragment>
			<div className="form-clients-title">
				<CgCloseO
					cursor="pointer"
					color={"var(--textColor)"}
					size={23}
					onClick={() => close()}
				/>
			</div>
			{props.urlLogo && (
				<div className="form-clients-avatar-container">
					<Image
						imgId={props.urlLogo}
						alt="profile"
						className="form-clients-avatar"
						onlyImage={true}
					/>
					<Spacer marginBottom="10" />
				</div>
			)}
		</React.Fragment>
	) : (
		<PageTitle
			className={props.className}
			backRoute={backRoute}
			title={props.tituloCadastro}
			text={props.text}
			icon={props.icon}
		/>
	);
};

export default FormTitle;
